const styles = {
  gridElements: {
    zIndex: 1,
  },
  listTextTitles: {
    mb: 1,
  },

}

export default styles
